import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';

import IconPlus from 'components/icons/IconPlus';
import IconShield from 'components/icons/IconShield';
import Section, {
  SectionHeader, SectionTitle, SectionBody, SectionBodyEmptyContent,
} from 'components/common/Section';
import Button from 'components/common/Button';
import InsuranceCreateEditDialog from 'components/patient/InsuranceCreateEditDialog';

import sortInsurance from 'utils/sortInsurance';

import InsuranceInformationItem from './InsuranceInformationItem';

const styles = theme => ({
  iconPlus: {
    width: 14,
    height: 14,
    marginRight: 10,
  },
  button: {
    marginLeft: 20,
  },
  iconShield: {
    width: 16,
    height: 20,
  },
  tableCell: {
    paddingLeft: 8,
    paddingRight: 8,
    background: 'none',
    borderBottom: `1px solid ${theme.palette.primary.A400}`,
    '&:first-child': {
      paddingLeft: 25,
    },
  },
});

class InsuranceInformation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addDialogOpen: false,
    };

    this.onAddButtonClick = this.onAddButtonClick.bind(this);
    this.onAddDialogClose = this.onAddDialogClose.bind(this);
  }

  onAddButtonClick() {
    this.setState({ addDialogOpen: true });
  }

  onAddDialogClose() {
    this.setState({ addDialogOpen: false });
  }

  render() {
    const {
      classes,
      patient,
    } = this.props;

    return (
      <Section>
        <SectionHeader>
          <SectionTitle>
            Insurance Information
          </SectionTitle>
          <Button
            className={classes.button}
            variant="raised"
            disabled={!patient}
            onClick={this.onAddButtonClick}
          >
            <IconPlus className={classes.iconPlus} />
            Add
          </Button>
        </SectionHeader>
        <SectionBody padding="none">
          {(!patient || patient['Insurance Information'].length === 0
            || (patient['Insurance Information'].length === 1
            && patient['Insurance Information'][0]['Insurance Type'] === 'Self')) ? (
              <SectionBodyEmptyContent
                text="There are no insurance yet"
                icon={(
                  <IconShield className={classes.iconShield} />
                )}
              />
            ) : (
              <Table>
                <TableBody>
                  {
                    sortInsurance(patient['Insurance Information'].filter(item =>
                      !item['Insurance Type'] || item['Insurance Type'] !== 'Self'))
                      .map(item => (
                        <InsuranceInformationItem
                          key={item.ID}
                          {...{ 'User Record Number': patient['Record Number'] }}
                          {...item}
                        />
                      ))
                  }
                </TableBody>
              </Table>
            )}
        </SectionBody>
        {patient !== null &&
          <InsuranceCreateEditDialog
            open={this.state.addDialogOpen}
            onClose={this.onAddDialogClose}
            onSubmitSuccess={this.onAddDialogClose}
            {...{ 'User Record Number': patient['Record Number'] }}
            initialValues={{
              'Copay Type': 'None',
              'Insurance Status': 'Active',
              'Relation to Insured': 'Self',
              'Signature On File': true,
              'Contacts Phone': [
                {
                  Value: '',
                  Description: '',
                }
              ],
              'Contacts Fax': [
                {
                  Value: '',
                  Description: '',
                }
              ],
              'Contacts Email': [
                {
                  Value: '',
                  Description: '',
                }
              ],
            }}
            form="patientInsuranceInformationCreate"
          />
        }
      </Section>
    );
  }
}

InsuranceInformation.propTypes = {
  patient: PropTypes.shape({
    'Insurance Information': PropTypes.arrayOf(PropTypes.shape({
      ID: PropTypes.number.isRequired,
    })),
  }),
  classes: PropTypes.shape({
    iconPlus: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    iconShield: PropTypes.string.isRequired,
    tableCell: PropTypes.string.isRequired,
  }).isRequired,
};

InsuranceInformation.defaultProps = {
  patient: null,
};

export default withStyles(styles)(InsuranceInformation);



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/InsuranceInformation/InsuranceInformation.js